import { API_BASE_URL } from "@/api/api.config";
import useRestQuery from "@/remoteState/useRestQuery";

const useGetPolls = ({
  shouldFetchTemplates,
  assignmentId,
  language,
  skip,
}) => {
  const params = {
    ...(shouldFetchTemplates && { is_template: 1 }),
    ...(assignmentId && { assignment_id: assignmentId }),
    ...(language && { language }),
  };
  const queryString = new URLSearchParams(params).toString();
  const resource = `${API_BASE_URL}/api/v3/activity/?${queryString}`;

  return useRestQuery(resource, {
    skip: skip || (!shouldFetchTemplates && !assignmentId),
  });
};

export default useGetPolls;
